import React, { useEffect, useState, useRef } from "react";
import { Divider } from "antd";
import { LinearProgress, Paper } from "@material-ui/core";
import { Table, Modal } from "react-bootstrap";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import "./styles.css";
const CharacterCertificate = () => {
  const currentDates = new Date().toISOString().slice(0, 10);
  const [currentsession, setcurrentsession] = useState("");
  const [admission_id, setAdmission_id] = useState("");
  const [editmodal, seteditmodal] = useState(false);
  const [date, setDate] = useState(currentDates);
  const [issueDate, setIssueDate] = useState(currentDates);
  const [studentName, setStudentName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [admissionDate, setAdmissionDate] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [leavingDate, setLeavingDate] = useState(currentDates);
  const [dateOfBithInWords, setDateOfBithInWords] = useState("");
  const [currentClassName, setCurrentClassName] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [campusName, setCampusName] = useState("");
  const [exam, setExam] = useState("---");
  const [obtainMarks, setObtainMarks] = useState(0);
  const [totalMarks, setTotalMarks] = useState(0);
  const [grade, setGrade] = useState("---");
  const [curricularDetails, setCurricularDetails] = useState("---");
  const [moralAttitude, setMoralAttitude] = useState("---");
  const [punctuality, setPunctuality] = useState("---");
  const [behaviour, setBehaviour] = useState("---");
  const [anyOther, setAnyOther] = useState("---");
  const [loading, setLoading] = useState(false);
  const [reportData, setreportData] = useState([]);
  const [sessioning, setallsession] = useState([]);
  const [certificate_Id, setCertificate_Id] = useState([]);
  const [totalFee, setTotalFee] = useState([]);
  const [campuschallans, setcampuschallans] = useState([]);
  const [duechallans, setduechallans] = useState([]);
  let authtoken = localStorage.getItem("userToken");
  const [icon, setIcon] = useState([]);
  const [unitName, setUnitName] = useState("");

  //for print
  const [printloading, setprintloading] = useState(false);
  const [saveButton, setSaveButton] = useState(false);

  var inputDate = "";
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();

  // Function to convert year to words
  // Function to convert a date string to a custom format
  function formatDate(inputDate) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const parts = inputDate.split("-");
    const day = parseInt(parts[2]);
    const month = parseInt(parts[1]) - 1; // Months are 0-indexed in JavaScript's Date object
    const year = parseInt(parts[0]);

    const dayWords = [
      "Zeroth",
      "First",
      "Second",
      "Third",
      "Fourth",
      "Fifth",
      "Sixth",
      "Seventh",
      "Eighth",
      "Ninth",
      "Tenth",
      "Eleventh",
      "Twelveth",
      "Thirteenth",
      "Fourteenth",
      "Fifteenth",
      "Sixteenth",
      "Seventeenth",
      "Eighteenth",
      "Nineteenth",
      "Twentieth",
      "Twenty-first",
      "Twenty-second",
      "Twenty-third",
      "Twenty-fourth",
      "Twenty-fifth",
      "Twenty-sixth",
      "Twenty-seventh",
      "Twenty-eighth",
      "Twenty-ninth",
      "Thirtieth",
      "Thirty-first",
    ];

    const formattedDate = `${dayWords[day]} ${months[month]} ${yearToWords(
      year
    )}`;
    return formattedDate;
  }

  // Function to convert year to words
  function yearToWords(year) {
    const numWords = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Sight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tensWords = [
      "",
      "One ",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (year >= 1000 && year <= 9999) {
      const thousands = Math.floor(year / 1000);
      const hundreds = Math.floor((year % 1000) / 100);
      const tens = Math.floor((year % 100) / 10);
      const ones = year % 10;

      const thousandsWord = numWords[thousands];
      const hundredsWord = numWords[hundreds];
      const tensWord = tensWords[tens];
      const onesWord = numWords[ones];
      if (hundreds === 0) {
        if (tens === 0) {
          return `${thousandsWord} Thousand ${onesWord}`;
        } else if (tens === 1) {
          return `${thousandsWord} Thousand ${numWords[tens * 10 + ones]}`;
        } else {
          return `${thousandsWord} Thousand ${tensWord} ${onesWord}`;
        }
      } else if (tens === 1) {
        return `${thousandsWord} Thousand ${hundredsWord} Hundred ${
          numWords[tens * 10 + ones]
        }`;
      } else {
        return `${thousandsWord} Thousand ${hundredsWord} Hundred ${tensWord} ${onesWord}`;
      }

      return "Invalid year";
    }
  }

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}-${d.getFullYear()}`;
  };

  useEffect(() => {
    getallsessions();
    max_id();
    getSettingData();
  }, []);

  const getallsessions = async () => {
    await fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsession(data.payload);
        data.payload.map((session, index) => {
          if (session.active_financial_year == "1") {
            setcurrentsession(session.id);
            setSessionName(session.year);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const max_id = async () => {
    await fetch(`${baseUrl}/certificate-max-id`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCertificate_Id(parseInt(data.payload) + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(data.payload.settings.unit_name);
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleShow = () => {
    setreportData([]);
    setStudentName("");
    setFatherName("");
    setAdmissionDate("");
    setDateOfBirth("");
    setCurrentClassName("");
    setSectionName("");
    setCampusName("");
    setCurrentClassName("");
    setExam("---");
    setObtainMarks(0);
    setTotalMarks(0);
    setGrade("---");
    setMoralAttitude("---");
    setPunctuality("---");
    setBehaviour("---");
    setAnyOther("---");
    setCurricularDetails("---");
    setDateOfBithInWords("");
    setcampuschallans([]);
    setduechallans([]);
    var hf = 0;
    setTotalFee(hf);
    if (admission_id == "" && date == "") {
      alert.error("please enter the Student ID and select the date");
      return;
    }
    if (date == "") {
      alert.error("please select the date");
      return;
    }
    if (admission_id == "") {
      alert.error("please enter the Student");
      return;
    }
    setLoading(true);
    setprintloading(true);
    setSaveButton(true);
    const data = {
      admission_id: admission_id.toLocaleUpperCase(),
      certificate_type: "3",
    };
    fetch(`${baseUrl}/collage-certificate`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setLoading(false);
          setSaveButton(false);
          setprintloading(false);

          data.payload.map((campusData) => {
            inputDate = campusData.dob;
            setreportData(data.payload);
            setDateOfBithInWords(formatDate(inputDate));

            setStudentName(campusData.name);
            setFatherName(campusData.father_name);
            setAdmissionDate(campusData.joining_date);
            setDateOfBirth(campusData.dob);
            setCurrentClassName(campusData.student_class.name);
            setSectionName(campusData.global_section.name);
            setCampusName(campusData.campus.name);

            if (
              campusData.certificate.length > 0 &&
              campusData?.certificate[0]?.certificate_type_id == 3
            ) {
              setExam(campusData.certificate[0]?.exam);
              setObtainMarks(campusData.certificate[0]?.obtain_marks);
              setTotalMarks(campusData.certificate[0]?.total_marks);
              setLeavingDate(campusData.certificate[0]?.leaving_date);
              setGrade(campusData.certificate[0]?.grade);
              setCurricularDetails(campusData.certificate[0]?.activity);
              setIssueDate(campusData.certificate[0]?.issue_date);
              setprintloading(true);
            } else if (
              campusData.certificate.length > 0 &&
              campusData?.certificate[1]?.certificate_type_id == 3
            ) {
              setExam(campusData.certificate[1]?.exam);
              setObtainMarks(campusData.certificate[1]?.obtain_marks);
              setTotalMarks(campusData.certificate[1]?.total_marks);
              setLeavingDate(campusData.certificate[1]?.leaving_date);
              setGrade(campusData.certificate[1]?.grade);
              setCurricularDetails(campusData.certificate[1]?.activity);
              setIssueDate(campusData.certificate[1]?.issue_date);
              setprintloading(true);
            } else if (
              campusData.certificate.length > 0 &&
              campusData?.certificate[2]?.certificate_type_id == 3
            ) {
              setExam(campusData.certificate[2]?.exam);
              setObtainMarks(campusData.certificate[2]?.obtain_marks);
              setTotalMarks(campusData.certificate[2]?.total_marks);
              setLeavingDate(campusData.certificate[2]?.leaving_date);
              setGrade(campusData.certificate[2]?.grade);
              setCurricularDetails(campusData.certificate[2]?.activity);
              setIssueDate(campusData.certificate[2]?.issue_date);
              setprintloading(true);
            }
          });
        } else {
          alert.error("Record Not Found");
          setLoading(false);
          return;
        }
        seteditmodal(true);

        fetch(
          `${baseUrl}/all-challan-search-for-certificate?id=${admission_id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            data.map((campusx) => {
              hf =
                hf + parseFloat(campusx.payable == null ? 0 : campusx.payable);
            });
            setTotalFee(hf);
            setcampuschallans(data);
            if (data == "") {
              alert.show("No Unpaid Challans Found");
            }
          })
          .catch((err) => {
            console.log(err);
          });
        //end challan data
        fetch(`${baseUrl}/paid-challan-search?id=${admission_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authtoken}`,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.payload == null) {
              setduechallans([]);
            } else {
              setduechallans(data.payload.fee_challan_details1.fee_month);
            }
          });
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };

  const addNow = async () => {
    setprintloading(true);
    setSaveButton(true);
    if (issueDate == "") {
      alert.error("Set Issue Date");
      setSaveButton(false);
      setprintloading(true);
      return;
    }
    if (leavingDate == "") {
      alert.error("Set Leaving Date");
      setSaveButton(false);
      setprintloading(true);
      return;
    }

    const data = {
      admission_id: admission_id,
      exam: exam,
      obtain_marks: obtainMarks,
      total_Marks: totalMarks,
      grade: grade,
      moral_attitude: moralAttitude,
      punctuality: punctuality,
      behaviour: behaviour,
      any_other: anyOther,
      migration: curricularDetails,
      issue_date: issueDate,
      leaving_date: leavingDate,
      certificate_type: "3",
      attandance: 0,
      class_position: 0,
      passed_class: 0,
      total_attandance: 0,
    };

    console.log(data);
    fetch(`${baseUrl}/save-certificate`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        alert.success(data.payload);
      });
    setSaveButton(false);
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);
  const handleOnBeforeGetContent = React.useCallback(() => {
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(true);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const customFormatDate = (dateString) => {
    const date = new Date(dateString); // Parse the date
    const day = date
      .getDate()
      .toString()
      .padStart(2, "0"); // Get day
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get month (0-indexed)
    const year = date.getFullYear(); // Get year
    return `${day}-${month}-${year}`; // Return formatted date
  };

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {loading ? <LinearProgress /> : null}

        <div className="row mt-3">
          <div className="col-md-4">
            <b> Date:</b>
            <input
              max="9999-11-30"
              defaultValue={currentDates}
              onChange={(e) => setDate(e.target.value)}
              type="date"
              placeholder="Enter Student ID"
              className="form-control"
              style={{ marginTop: "5px" }}
            />
          </div>
          <div className="col-md-4">
            <b> Student Admission ID:</b>
            <input
              onChange={(e) => setAdmission_id(e.target.value)}
              type="text"
              placeholder="Enter Student ID"
              className="form-control"
              style={{ marginTop: "5px" }}
            />
          </div>
          <div className="col d-flex mt-7">
            <button onClick={handleShow} className="btn btn-primary">
              Search
            </button>
          </div>
        </div>
        <Divider />

        {reportData.map((campus, index) => (
          <div key={index} className="mainContainer">
            <div>
              <div className="row mt-3">
                <h3>Admission Form Information</h3>
                <div className="col-md-6" style={{ marginTop: "20px" }}>
                  <b> Student Name:</b>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={campus.name}
                    id="sname"
                    style={{ marginTop: "5px" }}
                    disabled
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "19px" }}>
                  <b> Father Name:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    style={{ marginTop: "5px" }}
                    defaultValue={campus.father_name}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b> Serial No:</b>
                  <input
                    style={{ marginTop: "5px" }}
                    type="text"
                    className="form-control"
                    defaultValue={
                      campus.certificate[0]?.id == null
                        ? certificate_Id
                        : campus.certificate[0]?.id
                    }
                    id="srl"
                    disabled
                  />
                </div>

                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b>Admission Date:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="adate"
                    style={{ marginTop: "5px" }}
                    defaultValue={campus.joining_date}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  {" "}
                  <b> Date of birth:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="adob"
                    style={{ marginTop: "5px" }}
                    defaultValue={campus.dob}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  {" "}
                  <b> Date of birth In Words:</b>
                  <input
                    type="text"
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="adobw"
                    defaultValue={dateOfBithInWords}
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b> Session</b>
                  <select
                    className="form-control"
                    defaultValue={currentsession}
                    id="sessioner"
                    style={{ marginTop: "5px" }}
                    disabled
                  >
                    <option value="">Select Session</option>
                    {sessioning.map((classing, index) => (
                      <option key={index} value={classing.id}>
                        {classing.year}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b>Study In Class:</b>
                  <input
                    type="text"
                    className="form-control"
                    value={currentClassName}
                    onChange={(e) => setCurrentClassName(e.target.value)}
                    id="cclass"
                    style={{ marginTop: "5px" }}
                    placeholder="Enter Class Name"
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b>Campus:</b>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={campus.campus.name}
                    id="ccampus"
                    style={{ marginTop: "5px" }}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  {" "}
                  <b> Course:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="student_course"
                    style={{ marginTop: "5px" }}
                    defaultValue={campus.course.name}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  {" "}
                  <b> Section:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="csection"
                    style={{ marginTop: "5px" }}
                    defaultValue={campus.global_section.name}
                    disabled
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b> Issue Date:</b>
                  <input
                    type="date"
                    className="form-control"
                    style={{ marginTop: "5px" }}
                    value={issueDate}
                    id="idate"
                    onChange={(e) => setIssueDate(e.target.value)}
                  />
                </div>
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <b> Leaving Date:</b>
                  <input
                    type="date"
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    value={leavingDate}
                    id="ldate"
                    onChange={(e) => setLeavingDate(e.target.value)}
                  />
                </div>
                <div className="col-md-12" style={{ marginTop: "20px" }}>
                  <h3>Character Certificate Information</h3>
                </div>
                <div className="col-md-6" style={{ marginTop: "20px" }}>
                  <b> Examination:</b>
                  <input
                    type="text"
                    className="form-control"
                    id="pclass"
                    style={{ marginTop: "5px" }}
                    onChange={(e) => setExam(e.target.value)}
                    value={exam}
                    placeholder="Enter Examination"
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "10px" }}>
                  <b> Grade:</b>
                  <input
                    type="text"
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="classposition"
                    onChange={(e) => setGrade(e.target.value)}
                    value={grade}
                    placeholder="Enter Grade"
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "20px" }}>
                  <b>Obtained Marks</b>
                  <input
                    type="number"
                    className="form-control"
                    id="omarks"
                    style={{ marginTop: "5px" }}
                    onChange={(e) => setObtainMarks(e.target.value)}
                    value={obtainMarks}
                    placeholder="Enter Obtained Marks"
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "20px" }}>
                  <b> Total Marks</b>
                  <input
                    type="number"
                    className="form-control"
                    id="tmarks"
                    style={{ marginTop: "5px" }}
                    onChange={(e) => setTotalMarks(e.target.value)}
                    value={totalMarks}
                    placeholder="Enter Total Marks"
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "10px" }}>
                  <b>Moral Attitude</b>
                  <textarea
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="moral_attidude"
                    onChange={(e) => setMoralAttitude(e.target.value)}
                    value={moralAttitude}
                    placeholder="Enter Moral Attitude"
                  />
                </div>

                <div className="col-md-6" style={{ marginTop: "10px" }}>
                  <b>Punctuality</b>
                  <textarea
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="punctuality"
                    onChange={(e) => setPunctuality(e.target.value)}
                    value={punctuality}
                    placeholder="Enter Punctuality"
                  />
                </div>

                <div className="col-md-6" style={{ marginTop: "10px" }}>
                  <b>Behaviour</b>
                  <textarea
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="coco"
                    onChange={(e) => setBehaviour(e.target.value)}
                    value={behaviour}
                    placeholder="Enter Behaviour"
                  />
                </div>
                <div className="col-md-6" style={{ marginTop: "10px" }}>
                  <b>Any Other</b>
                  <textarea
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="any_other"
                    onChange={(e) => setAnyOther(e.target.value)}
                    value={anyOther}
                    placeholder="Enter Any Other"
                  />
                </div>
                <div className="col-md-12" style={{ marginTop: "10px" }}>
                  <b>Co-Curricular Activites</b>
                  <textarea
                    style={{ marginTop: "5px" }}
                    className="form-control"
                    id="coco"
                    onChange={(e) => setCurricularDetails(e.target.value)}
                    value={curricularDetails}
                    placeholder="Enter Co-Curricular Activities"
                  />
                </div>
                <div className="col-md-12" style={{ marginTop: "10px" }}>
                  <ReactToPrint
                    documentTitle={`Character Certificate`}
                    onAfterPrint={handleAfterPrint}
                    onBeforeGetContent={handleOnBeforeGetContent}
                    onBeforePrint={handleBeforePrint}
                    removeAfterPrint={true}
                    trigger={() => (
                      <button
                        disabled={printloading ? false : true}
                        style={{ marginLeft: "10px", float: "right" }}
                        className="btn btn-primary w-105px"
                      >
                        Print
                      </button>
                    )}
                    content={() => componentRef.current}
                  />
                  <button
                    onClick={addNow}
                    className="btn btn-primary"
                    style={{ float: "right" }}
                    disabled={saveButton}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}

        <Modal show={editmodal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Pending Fee Challans
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive>
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }} width="20%">
                    Challan No
                  </th>
                  <th style={{ textAlign: "center" }} width="40%">
                    Name
                  </th>
                  <th style={{ textAlign: "center" }} width="20%">
                    Fee Month
                  </th>
                  <th style={{ textAlign: "center" }} width="20%">
                    Payable
                  </th>
                </tr>
              </thead>
              <tbody>
                {campuschallans.map((campus, index) => (
                  <tr key={index}>
                    <td>&nbsp;&nbsp;{campus.challan_no}</td>
                    <td>&nbsp;&nbsp;{campus.student.name}</td>
                    <td>
                      {getMonthName(campus.fee_challan_details[0].fee_month)}
                    </td>
                    <td>{campus.payable}</td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td> Net Fee:</td>
                  <td>{totalFee}</td>
                </tr>
              </tbody>
            </Table>

            <button
              onClick={() => {
                seteditmodal(false);
                // setBestOption([]);
                // setFruitOne([]);
                // setChecked([]);
                //  handleSearch();
              }}
              style={{ float: "right" }}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Body>
        </Modal>

        {/* //for print///// */}
        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div
            className="mainContainer"
            style={{
              margin: "30px",
              border: "2px solid black",
              height: "1500px",
            }}
          >
            <div className="logocontainer" style={{ height: "280px" }}>
              <div>
                <center>
                  <img
                    // className='col-md-2'
                    style={{
                      height: 170,
                      width: 170,
                      display: "inline-block",
                      textAlign: "center",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    src={icon}
                  />
                </center>
                <br />{" "}
                <p
                  style={{
                    display: "block",
                    textAlign: "center",
                    fontSize: "40px",
                    fontFamily: "Times New Roman",
                    color: "black",
                  }}
                >
                  <b>{unitName}</b>
                </p>
                <p
                  style={{
                    display: "block",
                    textAlign: "center",
                    fontSize: "24px",
                    fontFamily: "Times New Roman",
                    color: "black",
                  }}
                >
                  <b>
                    105-A Stadium Road, Sargodha. Ph:048-3768749, 3768466,
                    0309-04008642
                  </b>
                </p>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                marginTop: "40px",
              }}
            >
              <div
                style={{
                  border: "2px solid black",
                  fontSize: "30px",
                  width: "500px",
                  color: "black",
                }}
              >
                <p
                  style={{ paddingTop: "10px", fontFamily: "Times New Roman" }}
                >
                  <b>CHARACTER CERTIFICATE</b>
                </p>{" "}
              </div>
            </div>

            <div style={{ marginTop: "40px" }}>
              <p
                style={{
                  fontSize: "24px",
                  lineHeight: "45px",
                  fontFamily: "Times New Roman",
                  color: "black",
                  fontStyle: "italic",
                }}
              >
                It is certified that Mr. / Miss.{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "730px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{studentName}</b>
                </span>{" "}
                S/o D/o{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "500px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{fatherName}</b>
                </span>{" "}
                whose particulars are give below has been a bonafide student of
                this college.
                <br />
                Class{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "410px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{currentClassName}</b>
                </span>{" "}
                Roll No.{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "170px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{admission_id}</b>
                </span>{" "}
                Session{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "195px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{sessionName}</b>
                </span>{" "}
                Date of Birth{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "345px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{customFormatDate(dateOfBirth)}</b>
                </span>{" "}
                Date of Admission{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "343px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{customFormatDate(admissionDate)}</b>
                </span>{" "}
                He / She Appeared in{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "340px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>Exam Current wala</b>
                </span>{" "}
                examination as a student of {unitName} & passed the examination
                in Grade{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "150px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>Grade ana ha</b>
                </span>{" "}
                securing{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{obtainMarks}</b>
                </span>{" "}
                out of{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  <b>{totalMarks}</b>
                </span>{" "}
                marks.
              </p>
            </div>

            <div style={{ marginTop: "40px" }}>
              <p
                style={{
                  fontSize: "28px",
                  fontFamily: "Times New Roman",
                  color: "black",
                }}
              >
                <b>Remarks</b>
              </p>
              <p
                style={{
                  fontSize: "24px",
                  lineHeight: "45px",
                  fontFamily: "Times New Roman",
                  color: "black",
                }}
              >
                Moral Attitude{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "865px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  {moralAttitude}
                </span>{" "}
                <br />
                Punctuality{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "900px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  {punctuality}
                </span>{" "}
                <br />
                Behaviour{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "910px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  {behaviour}
                </span>{" "}
                <br />
                Any Other{" "}
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "910px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  {anyOther}
                </span>{" "}
                <br />
              </p>
              <p
                style={{
                  fontSize: "24px",
                  fontFamily: "Times New Roman",
                  color: "black",
                  textAlign: "center",
                }}
              >
                Distinctions & achievements in Co-curricular activities <br />
                <span
                  style={{
                    borderBottom: "1px solid black",
                    width: "900px",
                    textAlign: "center",
                    display: "inline-block",
                  }}
                >
                  {curricularDetails}
                </span>{" "}
              </p>
            </div>
          </div>

          {/* signature row */}
          <p
            style={{
              fontSize: "24px",
              marginTop: "-120px",
              marginLeft: "5px",
              fontFamily: "Times New Roman",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "400px",
                textAlign: "center",
              }}
            >
              <label
                className="topline"
                style={{ width: "200px", textAlign: "center" }}
              >
                Class Incharge
              </label>
            </span>{" "}
            <span
              style={{
                display: "inline-block",
                width: "200px",
                marginLeft: "30px",
                textAlign: "center",
              }}
            ></span>{" "}
            <span
              style={{
                display: "inline-block",
                width: "180px",
                textAlign: "center",
              }}
            ></span>{" "}
            <label
              className="topline"
              style={{ width: "180px", textAlign: "center" }}
            >
              Principal
            </label>
          </p>
          <p
            style={{
              fontSize: "18px",
              float: "right",
              marginRight: "40px",
              marginTop: "20px",
            }}
          >
            www.dar.e.arqamgcs.edu.pk
          </p>
        </div>
      </Paper>
    </>
  );
};

export default CharacterCertificate;
